import angular from 'angular';

var module = angular.module('app.home', []);

export default module;